<template>
	<div class="pawn-products">
		<!-- banner -->
		<div class="banner">
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item v-for="(item, index) in sliders" :key="index">
					<img style="width:100%;height: auto" :src="item.img" class="slider_img"
						@click="getOpenMinChengXuLink">
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 我有汽车 -->
		<div id="car" class="car">
			<div class="head-label">
				<div class="f36">我有汽车</div>
				<div class="f14 red">CAR PAWN</div>
			</div>
			<div class="border_parent car-con">
				<div class="car-l">
					<img src="../../static/pawnProducts/car.png" alt="" />
				</div>
				<div class="car-r">
					<p class="f28 blod">全款车、按揭车、公司车皆可做</p>
					<div class="steps-list">
						<div class="steps-item" v-for="(item, i) in stepsArr" :key="i">
							<p class="red blod">STEP <span class="f24">{{ i+1 }}</span> </p>
							<p class="align-right">{{ item.des1 }}</p>
							<p class="align-right">{{ item.des2 }}</p>
							<img class="left-img" :src="item.leftImg" alt="" />
							<img class="left-img left-img-hover" src="../../static/pawnProducts/car-left-hover.png" alt="" />
						</div>
					</div>
					<div class="desc">
						<div class="desc-list">
							<div class="desc-item">
								<p class="f20 blod">额度<span class="red">高</span></p>
								<p class="c-6 f12">抵押成数可达9成</p>
							</div>
							<div class="desc-item">
								<p class="f20 blod">放款<span class="red">快</span></p>
								<p class="c-6 f12">30分钟可放款</p>
							</div>
							<div class="desc-item">
								<p class="f20 blod">用款<span class="red">灵活</span></p>
								<p class="c-6 f12">随借随用 循环用款</p>
							</div>
							<div class="desc-item">
								<p class="f20 blod">计息<span class="red">灵活</span></p>
								<p class="c-6 f12">支持部分还款 提前还款</p>
							</div>
							<div class="desc-item">
								<p class="f20 blod">快速<span class="red">签约</span></p>
								<p class="c-6 f12">评估后快速签约</p>
							</div>
							<div class="desc-item">
								<p class="f20 blod"><span class="red">专用</span>车库</p>
								<p class="c-6 f12">24小时监管</p>
							</div>
						</div>
					</div>
					<!--立即咨询 -->
					<div class="head-label seek">
						<a class="seek-btn" href="/#advice">立即咨询</a>
					</div>
				</div>
			</div>
		</div>
		<!-- 我有房产 -->
		<div id="house" class="house">
			<div class="house-con">
				<div class="head-label">
					<div class="f36">我有房产</div>
					<div class="f14 red">REAL ESTATE PAWN</div>
				</div>
				<div class="material-list">
					<div class="material-item">
						<p class="red f14 blod">REAL ESTATE</p>
						<p class="blod f20">房产典当业务范围</p>
						<div class="mt-30">
							<span class="red f16 blod">个人名下</span><br>
							<span>个人名下普通住宅、公寓、别墅、四合院、写字楼、商业用房；</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">公司名下</span><br>
							<span>公司名下住宅、办公用房、工业用房等；</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">个人名下</span><br>
							<span>个人名下普通住宅、公寓、别墅、四合院、写字楼、商业用房；</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">经济适用</span><br>
							<span>经济适用房、成本价房、回迁房等特殊住宅；</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">一抵房产</span><br>
							<span>有银行一抵的房产；</span>
						</div>
						<img class="top-img" src="../../static/pawnProducts/house-top-status.png" alt="" />
						<img class="top-img top-img-hover" src="../../static/pawnProducts/house-top-hover.png" alt="" />
					</div>
					<div class="material-item">
						<p class="red f14 blod">PERSONAL</p>
						<p class="blod f20">个人贷款所需材料</p>
						<div class="mt-30">
							<span class="red f16 blod">个人基础信息</span><br>
							<span>身份证、户口本、结婚证明、银行证明、个人</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">抵押基础信息</span><br>
							<span>房本</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">资金使用信息</span><br>
							<span>贷款用途、相关采购或贸易合同、其它贷款业务证明</span>
						</div>
						<img class="top-img" src="../../static/pawnProducts/house-top-status.png" alt="" />
						<img class="top-img top-img-hover" src="../../static/pawnProducts/house-top-hover.png" alt="" />
					</div>
					<div class="material-item">
						<p class="red f14 blod">COMPANY</p>
						<p class="blod f20">企业贷款所需材料</p>
						<div class="mt-30">
							<span class="red f16 blod">企业基础信息</span><br>
							<span>公司章程、公司简介、法人简历、法人身份证、营业执照、组织机构代码证、税务登记证、贷款卡及密码</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">企业财务信息</span><br>
							<span>近三年财务年报及近期报表、近一年企业账户流水</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">资金使用信息</span><br>
							<span>企业贷款用途说明及相关业务合同</span>
						</div>
						<div class="mt-20">
							<span class="red f16 blod">抵质押物信息</span><br>
							<span>房产证、土地证、固定资产权属证明、第三方担保公司相关材料</span>
						</div>
						<img class="top-img" src="../../static/pawnProducts/house-top-status.png" alt="" />
						<img class="top-img top-img-hover" src="../../static/pawnProducts/house-top-hover.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<!-- 黄金 奢品 数码 -->
		<div id="gold" class="all">
			<div class="head-label">
				<div class="f36">黄金 奢品 数码</div>
				<div class="f14 red">ALL CATEGORIES</div>
			</div>
			<div class="cate">
				<el-carousel :interval="4000" type="card" height="700px">
				    <el-carousel-item style="height: 700px;" v-for="(item, i) in categoriesArr" :key="i">
					  <img style="width: 100%;height: auto;" :src="item" alt="" />
				    </el-carousel-item>
				  </el-carousel>
			</div>
		</div>
		<!-- 业务流程 -->
		<div class="business">
			<div class="head-label">
				<div class="f36">业务流程</div>
				<div class="f14 red">BUSINESS PROCESS</div>
			</div>
			<div class="business-con">
				<div class="business-list">
					<div class="business-item" v-for="(item, i) in businessArr" :key="i">
						<p class="icon"><img  :src="item.icon" alt="" /></p>
						<p class="activeIcon"><img  :src="item.activeIcon" alt="" /></p>
						<p class="title">{{ item.title }}</p>
						<p class="des">{{ item.des }}</p>
						<div class="semi-circle">0{{ i+1 }}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 获取咨询 -->
		<div id="advice" class="advice">
			<div class="head-label">
				<div class="f36">获取咨询</div>
				<div class="f14 red">CAT ADVICE</div>
			</div>
			<div class="advice-con">
				<div class="con1">
					<p class="f24 blod">借款申请</p>
					<p class="f12 red">BORROWING APPLICATION</p>
					<div class="apply-advice">
						<p>
							<img src="../../static/pawnProducts/apply-icon1.png" alt="" />
							<input v-model="userName" class="advice-ipt" type="text" placeholder="请输入姓名" />
						</p>
						<p>
							<img src="../../static/pawnProducts/apply-icon2.png" alt="" />
							<input v-model="userPhone" class="advice-ipt" type="number" placeholder="请输入手机号" />
						</p>
						<p>
							<img src="../../static/pawnProducts/apply-icon3.png" alt="" />
							<input v-model="loanAmount" class="advice-ipt"  placeholder="请输入借款金额" />
						</p>
						<p class="btn" @click="submit">
							<span>立即申请</span>
						</p>
					</div>
				</div>
				<div class="con2">
					<div class="con2-l">
						<img class="avatar-img" src="../../static/pawnProducts/avatar.png" alt="" />
					</div>
					<div class="con2-c">
						<p class="blod f24">刘经理</p>
						<p>从事典当行业长达十余年，客户群体以个人及小微企业为主，擅长根据客户的抵押物价值、资金需求及还款能力，设计个性化的典当方案，以高效、灵活的服务满足客户的融资需求。</p>
					</div>
					<div class="con2-r">
						<!-- <span class="con2-r-btn">立即咨询</span> -->
					</div>
				</div>
				<div class="con3">
					<div class="con3-item" @click="handleLink('/myPawn')">
						<img src="../../static/pawnProducts/icon01.png" alt="" />快速申请
					</div>
					<div class="con3-item" @click="handleLink('/channel')">
						<img src="../../static/pawnProducts/icon02.png" alt="" />合作渠道入口
					</div>
					<div class="con3-item" @click="handleLink('/answer')">
						<img src="../../static/pawnProducts/icon03.png" alt="" />典当问答
					</div>
					<div class="con3-item" @click="handleLink('/walkInto')">
						<img src="../../static/pawnProducts/icon04.png" alt="" />门店信息
					</div>
				</div>
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>
<script>	
	import ApplyForm from '../components/ApplyForm.vue'
	import Address from '../components/Address.vue'
	import Process from '../components/Process.vue'
	import Dialog from '../components/Dialog.vue'
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		components: {ApplyForm,Address,Process,Dialog},
		data() {
			return {
				centerDialogVisible: false,
				userName: '',
				userPhone: '',
				loanAmount: '',
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				stepsArr: [
					{
						des1: '客户申请',
						des2: '鉴定评估',
						leftImg: require('../../static/pawnProducts/car-left-status.png')
					},
					{
						des1: '签约放款',
						des2: '车辆入库',
						leftImg: require('../../static/pawnProducts/car-left-status.png')
					},
					{
						des1: '到期还款',
						des2: '车辆出库',
						leftImg: require('../../static/pawnProducts/car-left-status.png')
					}
				],
				categoriesArr: [
					require('../../static/pawnProducts/all-banner1.png'),
					require('../../static/pawnProducts/all-banner2.png'),
					require('../../static/pawnProducts/all-banner3.png'),
				],
				businessArr: [{
					title: '业务接待',
					des: '顾客到店咨询，业务员接待顾客',
					icon: require('../../static/pawnProducts/pro-icon1.png'),
					activeIcon: require('../../static/pawnProducts/act-icon1.png'),
				},{
					title: '证件查验',
					des: '查验有效身份证件身份证、港澳台通行证、护照',
					icon: require('../../static/pawnProducts/pro-icon2.png'),
					activeIcon: require('../../static/pawnProducts/act-icon2.png'),
				},{
					title: '鉴定评估',
					des: '民品专家鉴定当物，并给出鉴定结论及评估价',
					icon: require('../../static/pawnProducts/pro-icon3.png'),
					activeIcon: require('../../static/pawnProducts/act-icon3.png'),
				},{
					title: '出当票付当金',
					des: '出具当票，客户签字，支付当金',
					icon: require('../../static/pawnProducts/pro-icon4.png'),
					activeIcon: require('../../static/pawnProducts/act-icon4.png'),
				},{
					title: '续当',
					des: '根据当票到期日办理续当业务',
					icon: require('../../static/pawnProducts/pro-icon5.png'),
					activeIcon: require('../../static/pawnProducts/act-icon5.png'),
				},{
					title: '赎当',
					des: '携带当票，有效证件到店办理赎当业务',
					icon: require('../../static/pawnProducts/pro-icon6.png'),
					activeIcon: require('../../static/pawnProducts/act-icon6.png'),
				}]
				// carousel_height: '550px',
			}
		},
		created() {},
		methods: {
			handleLink(path) {
				this.$router.push({
					path: path
				});
			},
			close(flag) {
				this.centerDialogVisible = flag
			},
			submit() {
				if (this.userName == '') {
					this.$message.error('请输入姓名');
					return false
				}
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				if (this.loanAmount == '') {
					this.$message.error('请输入金额');
					return false
				}
				
				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 0,
						userName: this.userName,
						userPhone: this.userPhone,
						loanAmount: this.loanAmount,
						clueType: 0,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible= true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
		mounted() {
			this.sliders = [{
					img: require("../../static/pawnProducts/banner01.png")
				}],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 400 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 400 / 1920 * this.screeWith
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
	}
</script>

<style scoped>
	.apply-advice {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.avatar-img {
		width: 146px;
		height: 146px;
	}
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #CF2427 !important;
	}
	
	.slider_img {
		height: 560px;
		width: 100%;
	}

	/* banner FORM style */
	.banner {
		position: relative;
	}
	
	
	.solve {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.border {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		height: auto;
		margin: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.border_one {
		margin-left: 0;
	}

	.border_img_parent {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.product_mobile_content {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.product_mobile_img {
		width: 50%;
	}

	.product_mobile_title {
		font-weight: bold;
		text-align: center;
	}

	.product_pc_one {
		text-align: center;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.font_size_30 {
		font-size: 1.875rem;
	}

	.product_font_style {
		font-size: 1.125rem;
	}

	.product_pc_img {
		width: 100%
	}

	.product_pc_img_div {
		width: 50%;
		float: left;
		display: flex;
		align-items: center;
	}

	.product_pc {
		display: flex;
		width: 90%;
		margin: 20px auto;
		background: #F2F6FC;
		align-items: center;
	}

	.product_spec_title {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.cooperation_parent {
		display: flex;
		justify-content: center;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.border_spec {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		float: left;
		width: 25%;
		height: auto;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.about_me_p {
		font-size: 1.25rem;
		font-weight: normal;
		padding: 0 20px;
		margin: 10px;
	}

	.border_title {
		font-family: "PingFang SC";
		margin-top: 10px;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
	}

	.border_content_one {
		margin-top: 20px;
		font-size: 1.125rem;
		text-align: center;
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125rem;
		margin-bottom: 25px;
		text-align: center;
	}

	.img_border {
		margin-top: 15px;
		width: 80px;
		height: 80px
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 35px;
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		text-align: center;
	}

	.border_spec_inner_last {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		margin-bottom: 25px;
		text-align: center;
	}

	.cooperation {
		margin-top: 30px;
		width: 100%;
	}

	.about_me {
		display: flex;
		margin-top: 30px;
		justify-content: center;
		width: 100%;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		background: #F2F6FC;
	}

	.product_mobile_img_div {
		width: 50%;
		height: auto;
	}

	.product_mobile_content_one {
		margin-top: 20px;
		text-align: center;
	}

	.product_mobile_content_two {
		margin-top: 10px;
		text-align: center;
	}

	/* 屏幕设备适配 max-device-width: 400px */
	@media screen and (max-device-width: 415px) {
		.slider_img {
			height: 250px;
			width: 100%;
		}


		.border_parent {
			display: flex;
			width: 90%;
			margin: auto;
			height: auto;
			flex-direction: column;
		}

		.border {
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			float: left;
			width: 100%;
			height: auto;
			margin: 10px 0 auto;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
				/*background: aquamarine;*/
		}

		.border_img_parent {
			margin-top: 0;

		}

		.product_mobile {
			width: 90%;
			align-items: center;
			margin: 20px auto;
			height: auto;
			background: #F2F6FC;
		}

		.product_mobile_content {
			width: 100%;
			margin-top: 15px;
		}

		.product_mobile_content_one {
			margin-top: 5px;
		}

		.product_mobile_content_two {
			margin-top: 5px;
		}

		.product_mobile_img_div {
			display: flex;
			width: 100%;
			height: auto;
			justify-content: center;
			margin-top: 10px;
			margin-bottom: 15px;
		}

		.product_mobile_img {
			float: left;
		}

		.product_mobile_title {
			font-weight: bold;
		}

		.product_pc_one {
			width: 100%;
			margin-top: 15px;
		}

		.font_size_30 {
			font-size: 1.25rem;
		}

		.product_font_style {
			font-size: 1rem;
		}

		.product_pc_img {
			height: 280px;
			width: 320px;
		}

		.product_pc_img_div {
			width: 100%;
			float: left;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;
		}

		.product_pc {
			display: flex;
			width: 90%;
			height: auto;
			margin: 20px auto;
			background: #F2F6FC;
			flex-direction: column;
		}

		

		.product_spec_parent {
			display: flex;
			width: 90%;
			align-items: center;
			justify-content: center;
			margin: 20px auto;
			height: auto;
			flex-direction: column;
		}

		.border_spec {
			float: left;
			height: auto;
			margin: 8px;
			width: 100%;
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}


		.border_title {
			font-family: "PingFang SC";
			margin-top: 5px;
			font-size: 1.125rem;
			font-weight: bold;
		}

		.border_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
		}

		.border_content_two {
			margin-top: 5px;
			font-size: 1.125rem;
			margin-bottom: 8px;
		}

		.img_border {
			margin-top: 8px;
			width: 80px;
			height: 80px
		}

		.border_spec_inner_one {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 8px;
			/*background-color: aqua;*/
			height: 70px;
		}

		.border_spec_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
		}

		.border_spec_inner_last {
			/*background-color: bisque;*/
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
			margin-bottom: 8px;
		}

		.about_me {
			display: flex;
			margin-top: 10px;
			width: 100%;
		}
	}

</style>


// WEBPACK FOOTER //
// src/view/pawnProducts.vue